import { render, staticRenderFns } from "./OneClickBuy.vue?vue&type=template&id=f4e495dc&scoped=true&"
import script from "./OneClickBuy.vue?vue&type=script&lang=js&"
export * from "./OneClickBuy.vue?vue&type=script&lang=js&"
import style0 from "./OneClickBuy.vue?vue&type=style&index=0&id=f4e495dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e495dc",
  null
  
)

export default component.exports